import { useDeleteNotifications } from 'api';
import * as React from 'react';
import { Alert } from 'ui';
import { NotificationTypeProps } from './notification-type-props';

export const Info: React.FC<NotificationTypeProps> = ({ notification }) => {
    const { mutate: deleteNotifications } = useDeleteNotifications();

    return (
        <Alert
            variant="success"
            text={notification.payload?.message}
            onDismiss={() => deleteNotifications([notification.id])}
        />
    );
};
